import { useEffect, useRef } from 'react';
import type React from 'react';

import { SECTION_ID_MAPPING } from '#src/app/pages/petitionDetails/shared/constants';

import { useScrollToSection } from '../../../../hooks/useScrollToSection';
import { MediaHitList } from '../MediaHitList';
import { useMediaHitScrollControl } from '../MediaHitList/hooks/useMediaHitScrollControl';

import { MediaHitsHeader } from './components/MediaHitsHeader';
import { useMediaHits } from './hooks/useMediaHits';

export const MediaHitsWrapper: React.FC = () => {
	const {
		data: { showAdd, showSection, showList, trackingData },
	} = useMediaHits();

	const {
		data: { refs },
	} = useScrollToSection();

	const mediaHitListRef = useRef<HTMLDivElement>(null);
	const {
		data: { canScrollLeft, canScrollRight, hasOverflow },
		actions: { updateScrollState, scrollByOneMediaHit },
	} = useMediaHitScrollControl(mediaHitListRef);

	// Update scroll state when content visibility changes (with delay for rendering)
	useEffect(() => {
		if (showList) {
			// Delay to allow MediaHitList to render its content
			const timer = setTimeout(updateScrollState, 100);
			return () => clearTimeout(timer);
		}

		return undefined;
	}, [showList, updateScrollState]);

	if (!showSection) {
		return null;
	}

	return (
		<div
			id={SECTION_ID_MAPPING.MEDIA_MENTIONS}
			ref={refs[SECTION_ID_MAPPING.MEDIA_MENTIONS]}
			data-testid="media-hits-wrapper"
			className="mx-auto mt-[52px] max-w-[1376px] overflow-x-hidden"
		>
			<div className="min-w-0 bg-[#FAF8FD] md:rounded-xl">
				<MediaHitsHeader
					showAdd={showAdd}
					trackingData={trackingData}
					onScrollLeft={() => scrollByOneMediaHit('left')}
					onScrollRight={() => scrollByOneMediaHit('right')}
					canScrollLeft={canScrollLeft}
					canScrollRight={canScrollRight}
					showScrollButtons={hasOverflow}
				/>

				{showList && <MediaHitList ref={mediaHitListRef} />}
			</div>
		</div>
	);
};
